module.exports = __webpack_public_path__ + "media/application/images/icons/icon-tools-65b0db6c55393083494994988c82be29.svg";